import { DATE_FORMAT, MIN_YEAR_LIMIT, MAX_YEAR_LIMIT } from "@/constants/datetime";
import { INVALID_DATE, INVALID_DATE_LIMIT_MIN, INVALID_DATE_LIMIT_MAX } from "@/constants/invalids";
import { replaceStr } from "@/utils/string";
import { dayjs } from "@/utils/dayjs";

// 転職勧奨禁止期間 is stored as a single date string in permanentEmploymentNote.
// Legacy values stored as "from～to" are read back as just the start date.
const LEGACY_SEPARATOR = "～";

// Read a stored value as a single date. Legacy "from～to" strings collapse to their start date.
export const parseBanPeriod = (value: string): string => {
  if (!value.includes(LEGACY_SEPARATOR)) return value.trim();
  const [from = ""] = value.split(LEGACY_SEPARATOR);
  return from.trim();
};
export const BAN_PERIOD_INVALID_MESSAGE = "「転職勧奨禁止期間」の日付が正しくありません。";

// Validation: blank is valid; a present value must be a real date within MIN/MAX bounds.
export const validateBanPeriod = (value: string): string => {
  const date = parseBanPeriod(value);
  if (!date) return "";
  const dJs = dayjs(date);
  const label = "転職勧奨禁止期間";
  if (!dJs.isValid()) return replaceStr(INVALID_DATE, { path: label });
  const year = dJs.year();
  if (year < MIN_YEAR_LIMIT) return replaceStr(INVALID_DATE_LIMIT_MIN, { path: label });
  if (year > MAX_YEAR_LIMIT) return replaceStr(INVALID_DATE_LIMIT_MAX, { path: label });
  return "";
};

export const isBanPeriodValid = (value: string): boolean => validateBanPeriod(value) === "";

// Display text: a single date formatted as YYYY/MM/DD (legacy ranges show only the start date).
export const formatBanPeriodDisplay = (value: string): string => {
  const date = parseBanPeriod(value);
  if (!date) return "";
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.format(DATE_FORMAT) : date;
};
